"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compressDocument = exports.compressNode = exports.compressElementNode = exports.compressFragmentNode = exports.compressProperties = exports.compressChildren = exports.stripHastDebug = exports.hasClass = exports.isElement = exports.isText = void 0;
exports.isText = function (node) { return node.type === 'text'; };
exports.isElement = function (node) { return node.type === 'element'; };
exports.hasClass = function (node, className) {
    return (node.properties &&
        node.properties.className &&
        node.properties.className.some(function (name) { return name === className; })) ||
        false;
};
exports.stripHastDebug = function (node) {
    if (exports.isText(node)) {
        return node;
    }
    var properties = node.properties &&
        Object.keys(node.properties).reduce(function (agg, key) {
            var _a;
            if (key !== '__source') {
                return __assign(__assign({}, agg), (_a = {}, _a[key] = node.properties[key], _a));
            }
            return agg;
        }, {});
    return __assign(__assign(__assign({}, node), (node.children && { children: node.children.map(exports.stripHastDebug) })), (properties && { properties: properties }));
};
exports.compressChildren = function (children) {
    return __assign({}, (children && children.length > 0 && { children: children }));
};
exports.compressProperties = function (properties) {
    return __assign({}, (properties && Object.keys(properties).length && { properties: properties }));
};
exports.compressFragmentNode = function (node) {
    return __assign({ type: 'element', tagName: 'fragment' }, exports.compressChildren(node.children));
};
exports.compressElementNode = function (node) {
    return __assign(__assign({ type: 'element', tagName: node.tagName }, exports.compressProperties(node.properties)), exports.compressChildren(node.children));
};
exports.compressNode = function (node) {
    if (exports.isText(node))
        return node;
    return exports.compressElementNode(node);
};
/** Remove all unnecessary properties from hast document */
exports.compressDocument = function (node) {
    if (exports.isText(node))
        return node;
    return __assign(__assign({ type: node.type, tagName: node.tagName }, exports.compressProperties(node.properties)), (node.children && exports.compressChildren(node.children.map(exports.compressDocument))));
};
